import React from "react"
import * as THREE from "three"
import { useEffect, useRef } from "react"
import { PositionalAudioHelper } from "three/addons/helpers/PositionalAudioHelper.js"
import { PositionalAudio, useGLTF, useHelper } from "@react-three/drei"
import { useControls } from "leva"
import { Interactive } from "@react-three/xr"
import { useClickStore, useScoreStore, useAudioStore, useResponseTimeStore, useModeStore } from "../store/store"
import { calculateScore } from "../utils"
import { AudioType, INTERVAL, ROUND_INTERVAL } from "../constants"
import Audio from "./Audio"
import MonoAudio from "./MonoAudio"

// BoomBox model bind to positional audio
const BoomBox = () => {
  const boomBox = useGLTF("./model/BoomBox.glb")
  const clockRef = useRef(new THREE.Clock())
  const positionalAudio = useRef()
  const audio = useRef()
  const click = useClickStore((state) => state.click)
  const increaseClick = useClickStore((state) => state.increaseClick)
  const increaseScore = useScoreStore((state) => state.increaseScore)
  const setAudioType = useAudioStore((state) => state.setAudioType)
  const audioType = useAudioStore(state => state.audioType)
  const defaultAudioTypeArr = useAudioStore(state => state.defaultAudioTypeArr)
  const setReponseTime = useResponseTimeStore(state => state.setResponseTime)
  const mode = useModeStore(state => state.mode)

  // useHelper(positionalAudio, PositionalAudioHelper)

  // debug
  const [{ position, random }, set] = useControls("BoomBox", () => ({ 
    position: { x: 0, y: 0, z: 0 },
    volume: { value: 1, min: 0, max: 1, onChange: (v) => {
      if(audioType === AudioType.POSITIONAL) positionalAudio.current?.setVolume(v)
      else audio.current?.setVolume(v)
    }},
    random: true,
    audioType: { 
      value: AudioType.POSITIONAL,
      options: {
        positional: AudioType.POSITIONAL,
        stereo: AudioType.STEREO,
        mono: AudioType.MONO,
      },
      onChange: (v) => {
        setAudioType(v)
      }
    }
  }))

  useEffect(() => {
    const timer = setInterval(() => {
      resetClock()
      if (random) randomlySetPosition()
    }, INTERVAL)

    return () => clearInterval(timer)
  }, [click, random])

  useEffect(() => {
    console.log(defaultAudioTypeArr)
    
    setAudioType(defaultAudioTypeArr[0])
    set({ audioType: defaultAudioTypeArr[0] })

    const timer1 = setTimeout(() => {
      setAudioType(defaultAudioTypeArr[1])
      set({ audioType: defaultAudioTypeArr[1] })
    }, ROUND_INTERVAL)

    const timer2 = setTimeout(() => {
      setAudioType(defaultAudioTypeArr[2])
      set({ audioType: defaultAudioTypeArr[2] })
    }, 2 * ROUND_INTERVAL)

    return () => {
      clearInterval(timer1)
      clearInterval(timer2)
    }
  }, [])

  const randomlySetPosition = () => {
    set({
      position: {
        x: 10 * (Math.random() - 0.5),
        y: 10 * Math.random(),
        z: 10 * (Math.random() - 0.5),
      },
    })
  }

  const resetClock = () => {
    clockRef.current = new THREE.Clock()
    clockRef.current.start()
  }

  const handleClick = () => {
    increaseClick(audioType)
    if (random) randomlySetPosition()
    setReponseTime(audioType, clockRef.current.getElapsedTime())
    increaseScore(calculateScore(clockRef.current.getElapsedTime()))
    resetClock()
  }

  const handleMissClick = () => {
    increaseClick(audioType, true)
  }

  return (
    <>
      <group position={[position.x, position.y, position.z]}>
        {audioType === AudioType.POSITIONAL && (
          <PositionalAudio
            ref={positionalAudio}
            url="./audio/badcat.mp3"
            distance={1}
            autoplay
            loop
          />
        )} 
        {audioType === AudioType.STEREO && <Audio ref={audio} url="./audio/badcat.mp3" />}
        {audioType === AudioType.MONO && <MonoAudio ref={audio} url="./audio/badcat.mp3" />}
        {mode === '3d' && 
          <primitive object={boomBox.scene} rotation-y={Math.PI} scale={20} onClick={handleClick} onPointerMissed={handleMissClick} />
        }
        {mode === 'vr' &&
          <Interactive onHover={handleClick}>
            <primitive object={boomBox.scene} rotation-y={Math.PI} scale={20} />
          </Interactive>
        }
      </group>
    </>
  )
}

export default BoomBox
